import React from 'react';
import { ReactComponent as IconSvg } from './plus.svg';
const AddSvg = ({ className }) => React.createElement(IconSvg, { className: className });
export default AddSvg;
